import { Link } from 'react-router-dom'
import { X } from 'lucide-react'

interface BreadcrumbProps {
  current: string
}

export default function Breadcrumb({ current }: BreadcrumbProps) {
  return (
    <div className="flex items-center gap-2 text-xs text-[#9A9A9A] pt-24 pb-4 px-6 lg:px-10">
      <Link to="/" className="hover:text-white transition-colors">HOME</Link>
      <X className="w-3 h-3" />
      <span className="text-[#B7000E] uppercase">{current}</span>
    </div>
  )
}
